import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import bg2 from "../../assets/images/bg/13.png";
import Home from "../../assets/images/bg/home.jpg";
import HomeM from "../../assets/images/bg/home-m.jpg";
import home1 from "../../assets/images/home/home.png";
import FeatureOne from "../../components/features/featuresOne";
import Navbar from "../../components/navbar";
import TinySlider from "tiny-slider-react";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../Config/FbConfig";

export default function IndexThree() {
  const [Notifications, setNotifications] = useState([]);
  const [Testimonials, setTestimonials] = useState([]);
  const [events, setEvents] = useState([]);

  console.log("Events:", events);
  const currentDate = new Date();

  const upcomingEvents = events.filter((post) => {
    const postDate = new Date(post.Date);
    return postDate > currentDate;
  });

  const [currentPage, setCurrentPage] = useState(1);
  const testimonialsPerPage = 4;
  const totalPages = Math.ceil(Testimonials.length / testimonialsPerPage);
  const indexOfLastTestimonial = currentPage * testimonialsPerPage;
  const indexOfFirstTestimonial = indexOfLastTestimonial - testimonialsPerPage;
  const currentTestimonials = Testimonials.slice(
    indexOfFirstTestimonial,
    indexOfLastTestimonial
  );
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [bgImage, setBgImage] = useState(
    window.innerWidth <= 768 ? HomeM : Home
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showModal, setShowModal] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setBgImage(window.innerWidth <= 768 ? HomeM : Home);
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [HomeM, Home]);

  const navigate = useNavigate();

  const handleViewDetails = (item) => {
    navigate(`/event-details/${item.Id}`);
  };

  let setting = {
    container: ".slider-range-three",
    items: 3,
    controls: false,
    mouseDrag: true,
    loop: true,
    rewind: true,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 3000,
    navPosition: "bottom",
    speed: 400,
    gutter: 24,
    responsive: {
      992: {
        items: 3,
      },

      767: {
        items: 2,
      },

      320: {
        items: 1,
      },
    },
  };

  useEffect(() => {
    const fetch_1 = async () => {
      try {
        const docRef = doc(firestore, "Home", "Notifications");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          var Data = [];
          Object.entries(docSnap.data()).forEach(([key, value]) => {
            Data.push(Object.assign({ Id: key }, value));
          });
          setNotifications(
            Data.sort(function (a, b) {
              return a.Priority - b.Priority;
            })
          );
        } else {
          setNotifications([]);
        }
      } catch (error) {
        console.error("Error fetching blogs: ", error);
      }
    };

    const fetch_2 = async () => {
      try {
        const docRef = doc(firestore, "Home", "Testimonials");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          var Data = [];
          Object.entries(docSnap.data()).forEach(([key, value]) => {
            Data.push(Object.assign({ Id: key }, value));
          });
          setTestimonials(
            Data.sort(function (a, b) {
              return a.Priority - b.Priority;
            })
          );
        } else {
          setTestimonials([]);
        }
      } catch (error) {
        console.error("Error fetching blogs: ", error);
      }
    };

    const fetch_3 = async () => {
      try {
        const docRef = doc(firestore, "Home", "Events");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          var Data = [];
          Object.entries(docSnap.data()).forEach(([key, value]) => {
            Data.push(Object.assign({ Id: key }, value));
          });
          setEvents(
            Data.sort(function (a, b) {
              return a.Priority - b.Priority;
            })
          );
        } else {
          setEvents([]);
        }
      } catch (error) {
        console.error("Error fetching blogs: ", error);
      }
    };
    fetch_1();
    fetch_2();
    fetch_3();
  }, []);

  const handleShowModal = (testimonial) => {
    setSelectedTestimonial(testimonial);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTestimonial(null);
  };

  return (
    <>
      <Navbar
        manuClass="navigation-menu nav-left nav-light"
        containerClass="container"
      />
      <section
        className="bg-half-170 d-table w-100"
        id="home"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div
          className="bg-overlay bg-overlay-dark"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        ></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="heading-title text-center">
                <h4 className="heading fw-bold text-white title-dark mt-3 mb-7">
                  Rangabandi Malavalli &reg;
                </h4>
                <p className="para-desc mx-auto text-white-50 mb-0">
                  On the stage of theatre, we discover not only characters but
                  also the depths of our own humanity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section" style={{ marginTop: "1rem" }}>
        <FeatureOne />
        <br />
        <div style={{ backgroundColor: "#b9b568c7", paddingTop: "2rem" }}>
          <marquee direction="left" style={{ whiteSpace: "nowrap" }}>
            {Notifications.length === 0
              ? "Loading..."
              : Notifications.map((data, i) => (
                  <a
                    key={i}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={data.Link}
                    style={{ display: "inline-block" }}
                  >
                    <h6 style={{ color: "white", display: "inline-block" }}>
                      {data.Header}
                      {Number(i + 1) !== Notifications.length ? (
                        <span>&emsp;|&emsp;</span>
                      ) : null}
                    </h6>
                  </a>
                ))}
          </marquee>
          <hr />
        </div>

        <br />

        <div className="container" style={{ marginBottom: "4rem" }}>
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-6">
              <img src={home1} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
              <div className="section-title ms-lg-5">
                <h4 className="title mt-3 mb-4">
                  The Significance and Aspirations of Theatre
                </h4>
                <p className="para-desc text-muted justify">
                  Theatre reflects and shapes cultural identities, traditions,
                  and societal values, offering a platform for diverse voices to
                  share their unique experiences. It fosters empathy by deeply
                  connecting audiences with characters and narratives,
                  broadening understanding of different perspectives. With a
                  rich history of addressing social issues through satire,
                  drama, and comedy, theatre inspires reflection and drives
                  change. Beyond its societal impact, it brings communities
                  together, encouraging creativity through a blend of acting,
                  music, dance, and visual arts, resulting in innovative
                  storytelling and artistic expression. Additionally, theatre
                  preserves cultural heritage and historical narratives,
                  educating future generations and maintaining a connection to
                  the past.
                </p>
                <p className="para-desc text-muted justify">
                  Participation in theatre enhances communication, teamwork, and
                  critical thinking skills while building confidence, especially
                  in children who may be introverted or stage-shy. Theatre helps
                  them express emotions, improves focus, and fosters academic
                  growth. It also serves as a tool for personal and social
                  development, providing inspiration, courage, and
                  self-assurance. Whether as an educational aid or a career
                  path, theatre remains a transformative and rewarding medium,
                  empowering individuals and communities alike
                </p>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <section className="section justify">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-4">Upcoming Events & Programme</h4>
                <p className="text-muted mx-auto para-desc mb-0">
                  Stay updated with our latest events and programs designed to
                  inspire and engage. Join us to explore new opportunities and
                  experiences that enrich your journey.
                </p>
              </div>
            </div>
          </div>

          <div className="container" style={{ marginTop: "1rem" }}>
            {events?.length > 0 ? (
              <div className="row">
                <div className="col-lg-12  mb-4 pt-2">
                  <div className="slider-range-three">
                    <TinySlider settings={setting}>
                      {events?.map((item, index) => (
                        <div
                          className="tiny-slide"
                          key={index}
                          style={{ marginBottom: "3rem" }}
                        >
                          <div className="card blog blog-primary border-0 shadow rounded overflow-hidden">
                            <img
                              src={item.Image}
                              className="img-fluid"
                              alt=""
                            />
                            <div className="card-body p-4">
                              <b className="one-line-truncate">{item.Header}</b>
                              <hr />
                              <small
                                className="two-line-truncate"
                                style={{ minHeight: "40px" }}
                              >
                                {item.Description}
                              </small>
                              <div className="post-meta d-flex justify-content-between mt-3">
                                <p
                                  onClick={() => handleViewDetails(item)}
                                  style={{
                                    cursor: "pointer",
                                    color: "#B9B569",
                                  }}
                                >
                                  View Details
                                  <i className="mdi mdi-chevron-right align-middle"></i>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </TinySlider>
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "1rem",
                }}
              >
                <h5>NO Data Available</h5>
              </div>
            )}
          </div>
        </section>

        <div
          style={{
            backgroundColor: "#b9b56863",
            borderTop: "1px solid #8A3C33",
            borderBottom: "1px solid #8A3C33",
          }}
        >
          <div style={{ padding: isMobile ? "1.5rem" : "5rem" }}>
            <div className="row">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "3rem",
                }}
              >
                <h4>Testimonials</h4>
              </div>
              {currentTestimonials?.length > 0 ? (
                currentTestimonials?.map((item, index) => (
                  <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={index}>
                    <div
                      style={{
                        background:
                          "linear-gradient(#facf1894, #facf1894 50%, #facf1833 50%, #facf1833)",
                        borderRadius: "10px",
                        padding: "30px",
                        textAlign: "center",
                        boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)",
                        transition: "transform 0.3s, box-shadow 0.3s",
                        position: "relative",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                        e.currentTarget.style.boxShadow =
                          "0 15px 30px rgba(0, 0, 0, 0.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 20px rgba(0, 0, 0, 0.1)";
                      }}
                    >
                      <h5 style={{ fontWeight: "bold" }}>{item.Name}</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                        }}
                      >
                        {item.Designation}
                      </p>
                      <div
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          margin: "0 auto",
                          position: "relative",
                          top: "40px", // Adjusted to position the image above the card
                          border: "5px solid #f5f0eb",
                        }}
                      >
                        <img
                          src={item.Image}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          background: "#fff",
                          padding: "20px",
                          borderRadius: "10px",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "1rem",
                            color: "#6c757d",
                            marginBottom: "20px",
                            marginTop: "2rem",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            WebkitLineClamp: 5,
                            textOverflow: "ellipsis",
                            textAlign: "justify",
                          }}
                        >
                          {item.MSG}
                        </p>
                        <button
                          onClick={() => handleShowModal(item)}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#B9B569",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          Read More
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <h4>No Data Found</h4>
                </div>
              )}
            </div>
            <div className="d-flex justify-content-center mt-4">
              <nav>
                <ul className="pagination">
                  {[...Array(totalPages)].map((_, pageIndex) => (
                    <li
                      key={pageIndex}
                      className={`page-item ${
                        currentPage === pageIndex + 1 ? "active" : ""
                      }`}
                    >
                      <a
                        style={{ backgroundColor: "#B9B569" }}
                        onClick={() => paginate(pageIndex + 1)}
                        className="page-link"
                        href="#!"
                      >
                        {pageIndex + 1}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>

          <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
              <Modal.Title>Testimonial</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedTestimonial && (
                <>
                  <h5 style={{ textAlign: "center" }}>
                    {selectedTestimonial.Name}
                  </h5>
                  <p style={{ textAlign: "center" }}>
                    {selectedTestimonial.Designation}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={selectedTestimonial.Image}
                      alt=""
                      style={{
                        height: "300px",
                        borderRadius: "12px",
                      }}
                    />
                  </div>
                  <p style={{ marginTop: "20px", textAlign: "justify" }}>
                    {selectedTestimonial.MSG}
                  </p>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                style={{
                  backgroundColor: "#B9B569",
                  border: "1px solid  #B9B569",
                }}
                onClick={handleCloseModal}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </section>

      <div style={{ marginBottom: "2rem" }}>
        <img src={bg2} alt="" style={{ width: "100%" }} />
      </div>
      <Footer />
      <ScrollTop />
    </>
  );
}
